export default "__VITE_ASSET__CNLb9rhY__"